import axios from 'axios';

const axiosRequest = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_NOTIFICATIONS,
});

export const sendFormToTelegram = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.post('/send-integration-form', body);
    dataCb?.();
  } catch (err) {
    console.log(err);
    errCb?.();
  }
};
